import { useNavigate } from "react-router-dom";
import { useAcceptInvite } from "../hooks/useAcceptInvite";
import styles from "../Auth.module.css";

export default function AcceptInvitePage() {
  const navigate = useNavigate();
  const { token, form, setField, loading, error, done, submit } = useAcceptInvite();

  if (!token) return null;

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {/* Logo */}
        <div className={styles.logo}>
          <svg width="32" height="32" viewBox="0 0 28 28" fill="none">
            <polygon points="14,2 26,8 26,20 14,26 2,20 2,8" stroke="#00e87a" strokeWidth="1.5" fill="none" />
            <polygon points="14,6 22,10 22,18 14,22 6,18 6,10" stroke="#00e87a" strokeWidth="1" fill="none" opacity="0.35" />
            <circle cx="14" cy="14" r="3" fill="#00e87a" />
          </svg>
          <span className={styles.logoText}>NPQ VPN</span>
        </div>

        {done ? (
          <>
            <h2 className={styles.title}>Account Created</h2>
            <p className={styles.subtitle}>Your account is ready. Redirecting to login…</p>
            <div className={styles.successIcon}>✓</div>
          </>
        ) : (
          <>
            <h2 className={styles.title}>Accept Invitation</h2>
            <p className={styles.subtitle}>Set up your account to join the enterprise workspace.</p>

            <div className={styles.form}>
              <div className={styles.formGrid2}>
                <div className={styles.fieldWrap}>
                  <label className={styles.fieldLabel}>First Name</label>
                  <input className={styles.input} placeholder="John"
                    value={form.firstName} onChange={setField("firstName")} />
                </div>
                <div className={styles.fieldWrap}>
                  <label className={styles.fieldLabel}>Last Name</label>
                  <input className={styles.input} placeholder="Doe"
                    value={form.lastName} onChange={setField("lastName")} />
                </div>
              </div>

              <div className={styles.fieldWrap}>
                <label className={styles.fieldLabel}>Password *</label>
                <input className={styles.input} type="password" placeholder="Min. 8 characters"
                  value={form.password} onChange={setField("password")} />
              </div>

              <div className={styles.fieldWrap}>
                <label className={styles.fieldLabel}>Confirm Password *</label>
                <input className={styles.input} type="password" placeholder="Repeat password"
                  value={form.confirm} onChange={setField("confirm")}
                  onKeyDown={(e) => e.key === "Enter" && submit()} />
              </div>

              {error && <div className={styles.errorBanner}>{error}</div>}

              <button className={styles.submitBtn} onClick={submit} disabled={loading}>
                {loading ? "Creating account…" : "Create Account"}
              </button>

              <button className={styles.linkBtn} onClick={() => navigate("/login")}>
                Already have an account? Sign in
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
